var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-fade-transition',[(_vm.loading)?_c('div',{staticClass:"pw-loader"},[_c('v-progress-linear',{attrs:{"indeterminate":"","color":"primary","height":"3","rounded":""}}),(_vm.label)?_c('div',{staticClass:"pw-loader__label"},[_vm._v(_vm._s(_vm.label))]):_vm._e()],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }